var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"canvas-text",style:({ width: _vm.cssWidth + 'px', height: _vm.cssHeight + 'px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }